import get from 'lodash/get';

function getPaymentConfigurationErrorMessage(state) {
  return get(
    state,
    ['paymentConfiguration', 'paymentConfigurationError', 'data', 'message'],
    ''
  );
}

export default getPaymentConfigurationErrorMessage;
